// Workspace.jsx
import React, { useEffect, useState, useRef } from 'react';
import Classes from './Workspace.module.css';
import Slider from './Slider';

// Static onboarding data
const staticOnboarding = {
  _id: "COMP123",
  color: "#3e9bff",
  scoringCriteria: [
    { name: "deckStructure", status: true },
    { name: "marketOpportunity", status: true }
  ]
};

const cardsData = [
  {
    name: "John Smith",
    project: "SEO",
    projectStatus: "Submitted",
    orderStarted: "March 1, 2025",
    orderDue: "March 5, 2025",
    tasks: [
      { name: "Optimize search engine visibility", status: "Submitted" },
      { name: "Redo the copywriting", status: "Submitted" }
    ],
    forms: [
      { name: "Onboarding form", status: "Submitted" },
      { name: "Assign form", status: "Select" }
    ],
    tickets: [],
    notes: []
  },
  {
    name: "Jeff Smith",
    project: "Website Redesign",
    projectStatus: "Working",
    orderStarted: "March 1, 2025",
    orderDue: "March 10, 2025",
    tasks: [
      { name: "Redo the hero section", status: "Submitted" },
      { name: "Redesign the dashboard", status: "Working" }
    ],
    forms: [
      { name: "Onboarding form", status: "In progress" },
      { name: "Assign form", status: "Select" }
    ],
    tickets: [{ message: "Need help with logo design", link: "View" }],
    notes: [{ message: "Jake - please review homepage", link: "View" }]
  },
  {
    name: "Tyler Smith",
    project: "SEO",
    projectStatus: "Submitted",
    orderStarted: "March 1, 2025",
    orderDue: "March 5, 2025",
    tasks: [
      { name: "Optimize search engine visibility", status: "Submitted" },
      { name: "Redo the copywriting", status: "Submitted" }
    ],
    forms: [
      { name: "Onboarding form", status: "Submitted" },
      { name: "Assign form", status: "Select" }
    ],
    tickets: [],
    notes: []
  },
  {
    name: "Jake Smith",
    project: "SEO",
    projectStatus: "Submitted",
    orderStarted: "March 1, 2025",
    orderDue: "March 5, 2025",
    tasks: [
      { name: "Optimize search engine visibility", status: "Submitted" },
      { name: "Redo the copywriting", status: "Submitted" }
    ],
    forms: [
      { name: "Onboarding form", status: "Submitted" },
      { name: "Assign form", status: "Select" }
    ],
    tickets: [],
    notes: []
  }
];

export default function Workspace() {
  const [openNotifications, setOpenNotifications] = useState(false);
  const NotificationsRef = useRef(null);
  const [workspace, setWorkspace] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setWorkspace(cardsData);
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (NotificationsRef.current && !NotificationsRef.current.contains(event.target)) {
        setOpenNotifications(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (staticOnboarding) {
      document.documentElement.style.setProperty('--dropdown-border', staticOnboarding.color || 'transparent');
    }
  }, []);

  return (
    <div className={Classes.hero}>
      <div className={Classes.header}>
        <div>
          <h3>Workspace</h3>
          <h5>Track and manage all of your client projects.</h5>
        </div>
        <div>
          <div className={Classes.searcCon}>
            <img src="/assets/images/search.png" alt="icon" />
            <input type="text" placeholder="Search..." />
          </div>
        </div>
      </div>

      <div className={Classes.hero2}>
        <Slider
          workspace={workspace}
          loading={loading}
          setLoading={setLoading}
          refetchWorkspace={() => setWorkspace(cardsData)}
        />
      </div>
    </div>
  );
}

